import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

export default function MobileStickyCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 px-3 pb-3 pt-2 bg-[var(--pc-bg)]/95 backdrop-blur-xl border-t pc-border z-50 md:hidden transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
      data-testid="mobile-sticky-cta"
    >
      <a
        href="#form-final"
        className="btn-primary w-full h-12 inline-flex items-center justify-center gap-2 text-[15px]"
      >
        Vérifier mon éligibilité
        <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
}
